import { render, staticRenderFns } from "./ScusPrice.vue?vue&type=template&id=50ecc136&"
import script from "./ScusPrice.vue?vue&type=script&lang=ts&"
export * from "./ScusPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports